import DashboardLayout from "../../lib/components/layouts/dashboard";
import PatientMembershipPackage from "../../lib/components/membershippackage/patient/patient-membership-package";
import { useContext } from "react";
import { AppContext } from "lib/contexts/app-context";
import { isPatientUser } from "lib/utils/util";
import { PAGE_ROUTES } from "lib/constants/page-routes";

const PatientMembershipPackagePage = () => {
  const { appState } = useContext(AppContext);

  const BreadcrumbItems = [
    {
      label: "Dashboard",
      path: isPatientUser(appState?.userRole)
        ? PAGE_ROUTES.PATIENT.Dashboard
        : PAGE_ROUTES.PRACTITIONER.Dashboard,
    },
    {
      label: "Membership Package",
      path: isPatientUser(appState?.userRole)
        ? PAGE_ROUTES.PATIENT.MembershipPackage
        : PAGE_ROUTES.PATIENT.BookAppointment,
    },
  ] as BreadcrumbItem[];

  return (
    <DashboardLayout breadcrumbItems={BreadcrumbItems}>
      <PatientMembershipPackage />
    </DashboardLayout>
  );
};

export default PatientMembershipPackagePage;
